module.exports = __webpack_public_path__ + "img/zwLogo.8e475e1b.png";